module.exports = __webpack_public_path__ + "img/elementwidths_jas.bf0eefd7.png";